import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import ProductosVendidos from './pages/ProductosVendidos';
import Planes from './pages/Planes';
import Tiendas from './pages/Tiendas';
import Negocios from './pages/Negocios';
import Alertas from './pages/Alertas';
import Configuracion from './pages/Configuracion';
import Usuarios from './pages/Usuarios';

function App() {
  const [autenticado,  setAutenticado]  = useState(!!localStorage.getItem('wm_admin_auth'));
  const [paginaActiva, setPaginaActiva] = useState('dashboard');

  function cerrarSesion() {
    localStorage.removeItem('wm_admin_auth');
    setAutenticado(false);
  }
  // Auto-logout por inactividad (15 minutos)
      useEffect(() => {
        let timer;

        function resetTimer() {
          clearTimeout(timer);
          timer = setTimeout(() => {
            cerrarSesion();
            alert('Tu sesión expiró por inactividad.');
          }, 15 * 60 * 1000); // 15 minutos
        }

        const eventos = ['mousemove','keydown','click','scroll','touchstart'];
        eventos.forEach(e => window.addEventListener(e, resetTimer));
        resetTimer();

        return () => {
          clearTimeout(timer);
          eventos.forEach(e => window.removeEventListener(e, resetTimer));
        };
      }, []);

  if (!autenticado) return <Login onLogin={() => setAutenticado(true)} />;

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'#F5F6FA' }}>
      <Sidebar paginaActiva={paginaActiva} onNavegar={setPaginaActiva} onCerrarSesion={cerrarSesion} />
      <div style={{ marginLeft:200, flex:1, padding:24 }}>
        {paginaActiva === 'dashboard'    && <Dashboard onNavegar={setPaginaActiva} />}
        {paginaActiva === 'productos'    && <ProductosVendidos tabInicial="suscripciones" />}
        {paginaActiva === 'ingresos'     && <ProductosVendidos tabInicial="ingresos" />}
        {paginaActiva === 'comisiones'   && <ProductosVendidos tabInicial="comisiones" />}
        {paginaActiva === 'planes'       && <Planes />}
        {paginaActiva === 'tiendas'      && <Tiendas />}
        {paginaActiva === 'negocios'     && <Negocios />}
        {paginaActiva === 'alertas'      && <Alertas />}
        {paginaActiva === 'config'       && <Configuracion />}
        {paginaActiva === 'usuarios'     && <Usuarios />}
      </div>
    </div>
  );
}

export default App;